(function () {
  var root = document.getElementById("riSingles");
  if (!root) return;

  var ENDPOINT = root.getAttribute("data-endpoint") || "";
  var STORAGE_KEY = "ri:singles-catalog:v2";
  var ALLOWED = {
    name: 1,
    title: 1,
    number: 1,
    finish: 1,
    set: 1,
    series: 1,
    released: 1,
    lang: 1,
    condition: 1,
    price: 1,
    qty: 1,
    image: 1,
    inventoriedAt: 1,
  };
  var SET_SHOW_MORE = 8;
  var SET_SEARCH_AT = 12;
  var CONDITION_BASE = { NM: 0, LP: 100, MP: 200, HP: 300, DMG: 400, DM: 400 };

  var cards = [];
  var search = "";
  var selectedSets = {};
  var selectedConditions = {};
  var selectedLanguages = {};
  var LANGUAGES = ["English", "Japanese", "Chinese"];
  var priceMin = 0;
  var priceMax = 0;
  var bounds = { min: 0, max: 0 };
  var sortKey = "newest";
  var setsExpanded = { English: false, Japanese: false };
  var picks = {};
  var setQuery = "";
  var boundsReady = false;
  var priceTouched = false;

  var statusEl = document.getElementById("riSinglesStatus");
  var facetsEl = document.getElementById("riSinglesFacets");
  var openFacetKey = "";
  var gridEl = document.getElementById("riSinglesGrid");
  var countEl = document.getElementById("riSinglesCount");
  var drawerCountEl = document.getElementById("riSinglesDrawerCount");
  var filterCountEl = document.getElementById("riSinglesFilterCount");
  var searchEl = document.getElementById("riSinglesSearch");
  var searchForm = document.getElementById("riSinglesSearchForm");
  var sortEl = document.getElementById("riSinglesSort");
  var colsEl = document.getElementById("riSinglesCols");
  var colsValueEl = document.getElementById("riSinglesColsValue");
  var COLS_KEY = "ri:singles-cols:v3";
  var COLS_MIN = 2;
  var COLS_MAX = 16;
  var colsCustom = false;
  /* Infinite scroll: no pages. The grid prints a first batch, then adds the next batches while the end of the
     grid is still a few screens below, so the shopper never scrolls into blank space. */
  var moreEl = document.getElementById("riSinglesMore");
  var AHEAD_SCREENS = 3;
  var gridList = [];
  var shown = 0;
  var phone = window.matchMedia("(max-width: 749px)");
  var barEl = document.getElementById("riSinglesBar");
  var barFacetsEl = document.getElementById("riSinglesBarFacets");
  var railEl = document.getElementById("riSinglesRail");
  var facetsHome = facetsEl ? facetsEl.nextElementSibling : null;
  var cardPhotos = null;

  function text(value, max) {
    return String(value == null ? "" : value)
      .replace(/[\u0000-\u001F\u007F]/g, "")
      .replace(/[<>]/g, "")
      .trim()
      .slice(0, max);
  }

  function httpsImage(value) {
    var raw = text(value, 500);
    if (!raw || raw.indexOf("https://") !== 0) return null;
    try {
      var url = new URL(raw);
      if (url.protocol !== "https:" || url.username || url.password) return null;
      return url.toString();
    } catch (e) {
      return null;
    }
  }

  function sanitizeCards(raw) {
    /* The server sends up to 20000 rows (in-stock printings plus the other printings of those cards). */
    if (!Array.isArray(raw) || raw.length > 20000) return [];
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var row = raw[i];
      if (!row || typeof row !== "object") continue;
      var keys = Object.keys(row);
      var extra = false;
      for (var k = 0; k < keys.length; k++) {
        if (!ALLOWED[keys[k]]) extra = true;
      }
      if (extra) continue;
      var name = text(row.name, 180);
      if (!name) continue;
      var price = Number(row.price);
      var qty = Math.floor(Number(row.qty));
      if (!isFinite(qty) || qty < 0 || qty > 999) continue;
      if (qty > 0 && (!isFinite(price) || price < 0 || price >= 100000)) continue;
      if (qty < 1) price = 0;
      var lang = String(row.lang || "").toUpperCase() === "JA" ? "JA" : "EN";
      var finish = text(row.finish, 80) || "Normal";
      /* Jumbo cards are never stocked, so that printing is left out everywhere (owner, 2026-10-23). */
      if (/jumbo/i.test(finish)) continue;
      out.push({
        name: name,
        title: text(row.title, 240) || name,
        number: text(row.number, 40) || null,
        finish: finish,
        set: text(row.set, 120) || null,
        series: text(row.series, 80) || null,
        released: /^\d{4}-\d{2}-\d{2}$/.test(String(row.released || "")) ? String(row.released) : null,
        lang: lang,
        condition: text(row.condition, 40) || "NM",
        price: Math.round(price * 100) / 100,
        qty: qty,
        image: httpsImage(row.image),
        inventoriedAt: addedStamp(row.inventoriedAt) ? new Date(addedStamp(row.inventoriedAt)).toISOString() : null,
      });
    }
    return out;
  }

  function loadSession() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return sanitizeCards(parsed && parsed.cards);
    } catch (e) {
      return [];
    }
  }

  function saveSession(list) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ cards: list }));
    } catch (e) {
      /* quota */
    }
  }

  function addedStamp(value) {
    var raw = text(value, 40);
    if (!raw) return 0;
    var t = Date.parse(raw);
    return isFinite(t) ? t : 0;
  }

  function compareAdded(a, b) {
    return addedStamp(b && b.inventoriedAt) - addedStamp(a && a.inventoriedAt) || a.name.localeCompare(b.name);
  }

  function groupAddedStamp(group) {
    var best = 0;
    var variants = (group && group.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].qty < 1) continue;
      var t = addedStamp(variants[i].inventoriedAt);
      if (t > best) best = t;
    }
    return best;
  }

  function conditionRank(value) {
    var raw = text(value, 40).toUpperCase().replace(/^\u2605\s*/, "");
    if (!raw) return 9999;
    var match = /^(NM|LP|MP|HP|DMG|DM)([+-]+)?$/.exec(raw);
    if (!match) return 9000 + raw.charCodeAt(0);
    var rank = CONDITION_BASE[match[1]];
    if (rank == null) rank = 500;
    var mod = match[2] || "";
    for (var i = 0; i < mod.length; i++) {
      if (mod.charAt(i) === "+") rank -= 30;
      else if (mod.charAt(i) === "-") rank += 30;
    }
    return rank;
  }

  function finishRank(value) {
    var n = text(value, 80).toLowerCase();
    if (!n || n === "normal") return 500;
    if (n.indexOf("1st") !== -1 || n.indexOf("first") !== -1) return 10;
    if (n.indexOf("shadowless") !== -1) return 80;
    if (n.indexOf("unlimited") !== -1) return 140;
    if (n.indexOf("reverse") !== -1) return 260;
    if (n.indexOf("holo") !== -1) return 200;
    return 400;
  }

  function setBoundsFromCards(list) {
    var min = 0;
    var max = 0;
    var sawPrice = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i].qty < 1) continue;
      if (!sawPrice) {
        min = list[i].price;
        max = list[i].price;
        sawPrice = true;
        continue;
      }
      if (list[i].price < min) min = list[i].price;
      if (list[i].price > max) max = list[i].price;
    }
    min = Math.floor(min);
    max = Math.ceil(max);
    if (max < min) max = min;
    bounds = { min: min, max: max };
    if (!boundsReady || !priceTouched) {
      priceMin = min;
      priceMax = max;
      boundsReady = true;
    } else {
      if (priceMin < min) priceMin = min;
      if (priceMax > max) priceMax = max;
      if (priceMin > priceMax) {
        priceMin = min;
        priceMax = max;
      }
    }
  }

  function selectedCount(map) {
    var n = 0;
    for (var key in map) if (map[key]) n += 1;
    return n;
  }

  function isChineseCondition(name) {
    return String(name || "").toUpperCase().indexOf("CHINESE") !== -1;
  }

  function cardLanguage(card) {
    if (isChineseCondition(card.condition)) return "Chinese";
    if (card.lang === "JA") return "Japanese";
    return "English";
  }

  function activeFacetCount() {
    var priceOn = priceMin > bounds.min || priceMax < bounds.max ? 1 : 0;
    return selectedCount(selectedSets) + selectedCount(selectedConditions) + selectedCount(selectedLanguages) + priceOn;
  }

  function cardBlob(card) {
    return (card.name + " " + card.title + " " + card.finish + " " + (card.set || "") + " " + (card.number || "")).toLowerCase();
  }

  /* Edit distance, stopping early once it is over max. */
  function editDistance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [];
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var cur = [i];
      var rowMin = i;
      for (var k = 1; k <= b.length; k++) {
        var cost = a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1;
        cur[k] = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + cost);
        if (cur[k] < rowMin) rowMin = cur[k];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  /* Typo pass, used only when the plain search finds nothing (Pikachy, Charzard). Every typed word
     must be in the card text or within 1 letter of one of its words (2 for words of 7+ letters). */
  function fuzzyMatch(words, blob) {
    var blobWords = blob.split(/[^a-z0-9à-ɏ]+/);
    for (var w = 0; w < words.length; w++) {
      var word = words[w];
      if (blob.indexOf(word) !== -1) continue;
      if (word.length < 4) return false;
      var max = word.length >= 7 ? 2 : 1;
      var hit = false;
      for (var b = 0; b < blobWords.length && !hit; b++) {
        var bw = blobWords[b];
        if (!bw) continue;
        if (editDistance(word, bw, max) <= max) hit = true;
        else if (bw.length > word.length && editDistance(word, bw.slice(0, word.length), max) <= max) hit = true;
      }
      if (!hit) return false;
    }
    return true;
  }

  function filteredCards() {
    var q = search.trim().toLowerCase();
    var fuzzyWords = null;
    if (q) {
      var exact = false;
      for (var e = 0; e < cards.length && !exact; e++) {
        if (cardBlob(cards[e]).indexOf(q) !== -1) exact = true;
      }
      if (!exact) fuzzyWords = q.split(/\s+/).filter(Boolean);
    }
    var list = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (q) {
        var blob = cardBlob(card);
        if (fuzzyWords ? !fuzzyMatch(fuzzyWords, blob) : blob.indexOf(q) === -1) continue;
      }
      if (selectedCount(selectedSets) > 0 && !selectedSets[card.set || ""]) continue;
      if (card.qty < 1) continue;
      if (selectedCount(selectedLanguages) > 0 && !selectedLanguages[cardLanguage(card)]) continue;
      if (selectedCount(selectedConditions) > 0 && !selectedConditions[card.condition]) continue;
      if (card.price < priceMin || card.price > priceMax) continue;
      list.push(card);
    }
    list.sort(function (a, b) {
      if (sortKey === "newest") return compareAdded(a, b);
      if (sortKey === "price-asc") return a.price - b.price || a.name.localeCompare(b.name);
      if (sortKey === "price-desc") return b.price - a.price || a.name.localeCompare(b.name);
      if (sortKey === "name-desc") return b.name.localeCompare(a.name);
      if (sortKey === "set-asc") return (a.set || "").localeCompare(b.set || "") || a.name.localeCompare(b.name);
      if (sortKey === "condition") return conditionRank(a.condition) - conditionRank(b.condition) || a.name.localeCompare(b.name);
      return a.name.localeCompare(b.name);
    });
    return list;
  }

  function cardKey(card) {
    return [card.lang, (card.set || "").toLowerCase(), (card.number || "").toLowerCase(), card.name.toLowerCase()].join("\u0001");
  }

  function variantKey(finish, condition) {
    return finish + "\u0001" + condition;
  }

  function indexVariants(group) {
    var map = {};
    for (var i = 0; i < group.variants.length; i++) {
      var row = group.variants[i];
      var key = variantKey(row.finish, row.condition);
      var prev = map[key];
      if (!prev) {
        map[key] = {
          finish: row.finish,
          condition: row.condition,
          price: row.price,
          qty: row.qty,
          image: row.image,
        };
      } else {
        prev.qty += row.qty;
        if (row.price < prev.price) prev.price = row.price;
        if (!prev.image && row.image) prev.image = row.image;
      }
    }
    group.options = map;
  }

  function sharpPhoto(url) {
    if (!url || url.indexOf("images.scrydex.com") === -1) return url;
    return url.replace(/\/small(?=$|[?#])/, "/large");
  }

  /* Scrydex large is a 600-730px PNG of 550-900KB. Medium is 367px and 60-100KB, which is still sharp on a
     tile up to about 420 device pixels wide (a default desktop row, or a phone at two across). */
  var MEDIUM_PHOTO_W = 367;
  function mediumPhoto(url) {
    if (!url || url.indexOf("images.scrydex.com") === -1 || !/\/large(?=$|[?#])/.test(url)) return null;
    return url.replace(/\/large(?=$|[?#])/, "/medium");
  }

  function tilePixels() {
    if (!gridEl) return 0;
    var n = columnCount();
    var width = gridEl.clientWidth;
    if (!width || !n) return 0;
    return (width / n) * Math.min(window.devicePixelRatio || 1, 2);
  }

  function photoForTile(full, need) {
    var medium = mediumPhoto(full);
    if (!medium || !need) return full;
    return need <= MEDIUM_PHOTO_W * 1.15 ? medium : full;
  }

  /* After Cards per row widens the tiles, swap medium photos that are now too small. */
  var upgradeQueued = false;
  function upgradeCardPhotos() {
    if (upgradeQueued || !gridEl) return;
    upgradeQueued = true;
    window.requestAnimationFrame(function () {
      upgradeQueued = false;
      var need = tilePixels();
      var imgs = gridEl.querySelectorAll("img[data-full]");
      for (var i = 0; i < imgs.length; i++) {
        var full = imgs[i].getAttribute("data-full");
        var src = imgs[i].getAttribute("src");
        if (src && src !== full && photoForTile(full, need) === full) imgs[i].src = full;
      }
    });
  }

  function cardPhoto(group) {
    var best = null;
    var bestRank = Infinity;
    for (var i = 0; i < group.variants.length; i++) {
      var row = group.variants[i];
      if (!row.image || row.qty < 1) continue;
      var rank = finishRank(row.finish) * 10000 + conditionRank(row.condition);
      if (rank < bestRank) {
        bestRank = rank;
        best = row.image;
      }
    }
    return best;
  }

  function optionList(group, field) {
    var seen = {};
    var out = [];
    for (var i = 0; i < group.variants.length; i++) {
      var value = group.variants[i][field];
      if (!value || seen[value]) continue;
      seen[value] = true;
      out.push(value);
    }
    if (field === "condition") {
      out.sort(function (a, b) { return conditionRank(a) - conditionRank(b) || a.localeCompare(b); });
    } else {
      out.sort(function (a, b) { return finishRank(a) - finishRank(b) || a.localeCompare(b); });
    }
    return out;
  }

  function findOption(group, finish, condition) {
    return group.options[variantKey(finish, condition)] || null;
  }

  function inStockOption(group, finish, condition) {
    var option = findOption(group, finish, condition);
    return option && option.qty > 0 ? option : null;
  }

  function bestConditionFor(group, finish) {
    var names = optionList(group, "condition");
    for (var i = 0; i < names.length; i++) {
      if (inStockOption(group, finish, names[i])) return names[i];
    }
    return names[0] || "";
  }

  function bestFinishFor(group, condition) {
    var names = optionList(group, "finish");
    for (var i = 0; i < names.length; i++) {
      if (inStockOption(group, names[i], condition)) return names[i];
    }
    return names[0] || "";
  }

  function stockedPick(group) {
    var conditions = optionList(group, "condition");
    var finishes = optionList(group, "finish");
    for (var c = 0; c < conditions.length; c++) {
      for (var f = 0; f < finishes.length; f++) {
        if (inStockOption(group, finishes[f], conditions[c])) {
          return { finish: finishes[f], condition: conditions[c] };
        }
      }
    }
    return null;
  }

  function finishStocked(group, finish) {
    var names = optionList(group, "condition");
    for (var i = 0; i < names.length; i++) {
      if (inStockOption(group, finish, names[i])) return true;
    }
    return false;
  }

  function conditionStocked(group, condition) {
    var names = optionList(group, "finish");
    for (var i = 0; i < names.length; i++) {
      if (inStockOption(group, names[i], condition)) return true;
    }
    return false;
  }

  function resolvePick(group) {
    var saved = picks[group.key];
    if (saved && inStockOption(group, saved.finish, saved.condition)) return saved;
    var stocked = stockedPick(group);
    var next = stocked || {
      finish: optionList(group, "finish")[0] || "",
      condition: optionList(group, "condition")[0] || "",
    };
    picks[group.key] = next;
    return picks[group.key];
  }

  function filteredGroups() {
    var rows = filteredCards();
    var map = {};
    var list = [];
    for (var i = 0; i < rows.length; i++) {
      var card = rows[i];
      var key = cardKey(card);
      if (!map[key]) {
        map[key] = {
          key: key,
          name: card.name,
          set: card.set,
          number: card.number,
          lang: card.lang,
          variants: [],
        };
        list.push(map[key]);
      }
      map[key].variants.push(card);
    }
    var everyone = {};
    for (var n = 0; n < cards.length; n++) {
      var allKey = cardKey(cards[n]);
      if (!everyone[allKey]) everyone[allKey] = [];
      everyone[allKey].push(cards[n]);
    }
    for (var g = 0; g < list.length; g++) {
      var full = everyone[list[g].key];
      if (full && full.length) list[g].variants = full.slice();
      indexVariants(list[g]);
    }
    list = list.filter(function (group) {
      return stockedPick(group);
    });
    list.sort(function (a, b) {
      var ap = resolvePick(a);
      var bp = resolvePick(b);
      var av = inStockOption(a, ap.finish, ap.condition);
      var bv = inStockOption(b, bp.finish, bp.condition);
      if (!av) {
        var aStock = stockedPick(a);
        av = aStock ? inStockOption(a, aStock.finish, aStock.condition) : null;
      }
      if (!bv) {
        var bStock = stockedPick(b);
        bv = bStock ? inStockOption(b, bStock.finish, bStock.condition) : null;
      }
      var aprice = av ? av.price : 0;
      var bprice = bv ? bv.price : 0;
      if (sortKey === "newest") return groupAddedStamp(b) - groupAddedStamp(a) || a.name.localeCompare(b.name);
      if (sortKey === "price-asc") return aprice - bprice || a.name.localeCompare(b.name);
      if (sortKey === "price-desc") return bprice - aprice || a.name.localeCompare(b.name);
      if (sortKey === "name-desc") return b.name.localeCompare(a.name);
      if (sortKey === "set-asc") return (a.set || "").localeCompare(b.set || "") || a.name.localeCompare(b.name);
      if (sortKey === "condition") return conditionRank(ap.condition) - conditionRank(bp.condition) || a.name.localeCompare(b.name);
      return a.name.localeCompare(b.name);
    });
    return list;
  }

  function allGroupsCount() {
    var seen = {};
    var n = 0;
    for (var i = 0; i < cards.length; i++) {
      var key = cardKey(cards[i]);
      if (seen[key]) continue;
      seen[key] = true;
      n += 1;
    }
    return n;
  }

  function moneyEl(price) {
    var wrap = document.createElement("span");
    wrap.className = "ri-money";
    var dollars = Math.round(Number(price) || 0);
    var symbol = document.createElement("span");
    symbol.className = "ri-money__symbol";
    symbol.textContent = "$";
    var dollarEl = document.createElement("span");
    dollarEl.className = "ri-money__dollars";
    dollarEl.textContent = String(dollars);
    wrap.appendChild(symbol);
    wrap.appendChild(dollarEl);
    return wrap;
  }

  /* Where the first card sits just under the header and the sticky phone bar. */
  function gridTop() {
    var header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue("--ri-header-sticky-h")) || 0;
    var bar = barEl ? barEl.getBoundingClientRect().height : 0;
    var y = gridEl.getBoundingClientRect().top + (window.pageYOffset || 0) - header - bar - 8;
    return Math.max(0, Math.round(y));
  }

  function scrollToResults() {
    if (!phone.matches) {
      window.scrollTo(0, 0);
      return;
    }
    window.scrollTo(0, gridTop());
  }

  /* Back to the top of the results after a search, only when the shopper is below them (never down the page). */
  function resultsToTop() {
    var target = phone.matches ? gridTop() : 0;
    if ((window.pageYOffset || 0) > target + 1) window.scrollTo(0, target);
  }

  function renderGrid(list) {
    releaseCardPhotos();
    gridEl.replaceChildren();
    if (!cards.length) {
      countEl.textContent = "";
      if (drawerCountEl) drawerCountEl.textContent = "";
      if (moreEl) moreEl.hidden = true;
      gridList = [];
      shown = 0;
      var clearIdle = document.getElementById("riSinglesClear");
      if (clearIdle) clearIdle.hidden = true;
      return;
    }
    var total = list.length;
    var all = allGroupsCount();
    var countText = "Showing 0 of " + all;
    if (total) countText = total === all ? total + (total === 1 ? " card" : " cards") : "Showing " + total + " of " + all;
    /* "Showing" is its own span so a phone can drop it and keep the count, Clear all, and Sort by on one line. */
    countEl.replaceChildren();
    if (countText.indexOf("Showing ") === 0) {
      var word = document.createElement("span");
      word.className = "ri-singles__count-word";
      word.textContent = "Showing ";
      countEl.appendChild(word);
      countEl.appendChild(document.createTextNode(countText.slice(8)));
    } else {
      countEl.textContent = countText;
    }
    if (drawerCountEl) drawerCountEl.textContent = countText;
    var clearEl = document.getElementById("riSinglesClear");
    if (clearEl) clearEl.hidden = !filtersActive();
    gridList = list;
    shown = 0;
    if (!total) {
      if (moreEl) moreEl.hidden = true;
      var empty = document.createElement("p");
      empty.className = "ri-singles__empty";
      empty.textContent = "No singles match.";
      gridEl.appendChild(empty);
      return;
    }
    appendBatch();
    fillAhead();
    queueCardPhotos();
  }

  /* About six rows per batch, whatever the cards-per-row setting. */
  function appendBatch() {
    var n = Math.max(24, columnCount() * 6);
    var slice = gridList.slice(shown, shown + n);
    if (!slice.length) return false;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < slice.length; i++) {
      frag.appendChild(tileEl(slice[i]));
    }
    gridEl.appendChild(frag);
    shown += slice.length;
    return true;
  }

  function aheadPx() {
    return Math.max(1600, (window.innerHeight || 800) * AHEAD_SCREENS);
  }

  /* Adds batches until the end of the grid is a few screens below the bottom of the screen (at most 8 per call;
     the next scroll adds more). */
  function fillAhead() {
    if (!moreEl) return false;
    var added = false;
    moreEl.hidden = shown >= gridList.length;
    for (var guard = 0; guard < 8 && shown < gridList.length; guard++) {
      /* A marker that is not drawn (the grid is out of view) cannot say where the end is: wait. */
      if (!moreEl.getClientRects().length) break;
      if (moreEl.getBoundingClientRect().top > window.innerHeight + aheadPx()) break;
      if (!appendBatch()) break;
      added = true;
    }
    moreEl.hidden = shown >= gridList.length;
    return added;
  }

  if (moreEl && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      if (!entries[0] || !entries[0].isIntersecting) return;
      if (fillAhead()) queueCardPhotos();
    }, { root: null, rootMargin: "0px 0px " + AHEAD_SCREENS * 100 + "% 0px", threshold: 0 }).observe(moreEl);
  }

  function watchCardPhotos() {
    if (cardPhotos) return cardPhotos;
    if (!("IntersectionObserver" in window)) return null;
    cardPhotos = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardPhotos.unobserve(entry.target);
        var box = entry.boundingClientRect;
        var inView = box.top < window.innerHeight && box.bottom > 0;
        startCardPhoto(entry.target, inView, inView);
      });
    }, { root: null, rootMargin: "800px 0px 1400px 0px", threshold: 0 });
    return cardPhotos;
  }

  function releaseCardPhotos() {
    if (cardPhotos) cardPhotos.disconnect();
  }

  function startCardPhoto(img, inView, high, need) {
    var full = img.getAttribute("data-src");
    if (!full || img.getAttribute("src")) return;
    img.loading = "eager";
    img.decoding = inView ? "auto" : "async";
    img.setAttribute("fetchpriority", high ? "high" : inView ? "auto" : "low");
    img.setAttribute("data-full", full);
    img.src = photoForTile(full, need == null ? tilePixels() : need);
    img.removeAttribute("data-src");
    if (inView && img.decode) img.decode().catch(function () {});
  }

  /* Cards just below the screen wait until the ones on screen have arrived (or 2.5s), so they do not share
     the connection with the photos the shopper is looking at. */
  function startAfter(onScreen, later, need) {
    var left = 0;
    var done = false;
    function go() {
      if (done) return;
      done = true;
      for (var i = 0; i < later.length; i++) {
        if (later[i].isConnected) startCardPhoto(later[i], false, false, need);
      }
    }
    function settle() {
      left -= 1;
      if (left <= 0) go();
    }
    for (var i = 0; i < onScreen.length; i++) {
      if (onScreen[i].complete) continue;
      left += 1;
      onScreen[i].addEventListener("load", settle, { once: true });
      onScreen[i].addEventListener("error", settle, { once: true });
    }
    if (!left) go();
    else window.setTimeout(go, 2500);
  }

  function queueCardPhotos() {
    var imgs = gridEl.querySelectorAll("img[data-src]");
    if (!imgs.length) return;
    var observer = watchCardPhotos();
    var viewBottom = window.innerHeight;
    var ahead = viewBottom + 1400;
    var highLeft = 8;
    var need = tilePixels();
    var onScreen = [];
    var later = [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var box = img.getBoundingClientRect();
      var inView = box.top < viewBottom && box.bottom > 0;
      var near = box.top < ahead && box.bottom > -800;
      if (!observer || inView) {
        if (observer) observer.unobserve(img);
        var high = inView && highLeft > 0;
        if (high) highLeft -= 1;
        startCardPhoto(img, inView, high, need);
        onScreen.push(img);
      } else if (near) {
        observer.unobserve(img);
        later.push(img);
      } else if (!img.riPhotoWatch) {
        img.riPhotoWatch = true;
        observer.observe(img);
      }
    }
    if (later.length) startAfter(onScreen, later, need);
  }

  var photoScrollQueued = false;
  function onPhotoScroll() {
    if (photoScrollQueued) return;
    photoScrollQueued = true;
    window.requestAnimationFrame(function () {
      photoScrollQueued = false;
      if (!gridEl) return;
      fillAhead();
      queueCardPhotos();
    });
  }
  window.addEventListener("scroll", onPhotoScroll, { passive: true });
  window.addEventListener("resize", onPhotoScroll);
  window.addEventListener("resize", upgradeCardPhotos);

  /* Back to top under the filters on a computer, once the page is more than two screens down (owner, 2026-10-23). */
  var topEl = document.getElementById("riSinglesTop");
  var topGoing = 0;
  if (topEl) {
    var syncTop = function () {
      /* Gone the moment it is clicked, and kept gone while the page glides up (owner, 2026-10-23: it stayed and
         stuttered up the column with the scroll). It can come back once the trip is over. */
      if (topGoing) {
        if (window.scrollY > window.innerHeight * 2 && Date.now() - topGoing < 1500) return;
        topGoing = 0;
      }
      topEl.hidden = !(window.scrollY > window.innerHeight * 2);
    };
    topEl.addEventListener("click", function () {
      topGoing = Date.now();
      topEl.hidden = true;
      var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: 0, behavior: still ? "auto" : "smooth" });
      var search = document.getElementById("riSinglesSearch");
      if (search) search.focus({ preventScroll: true });
    });
    window.addEventListener("scroll", syncTop, { passive: true });
    window.addEventListener("resize", syncTop);
    syncTop();
  }

  function syncSortLabel() {
    if (!sortEl) return;
    sortKey = sortEl.value;
    var valueEl = document.querySelector(".ri-singles__sort .ri-sort__value");
    var buttons = document.querySelectorAll(".ri-singles__sort .ri-sort__option");
    buttons.forEach(function (button) {
      var on = button.getAttribute("data-value") === sortKey;
      button.classList.toggle("is-current", on);
      if (on) {
        button.setAttribute("aria-current", "true");
        if (valueEl) valueEl.textContent = button.textContent;
      } else {
        button.removeAttribute("aria-current");
      }
    });
  }

  function bindTilt(art, img) {
    if (!img || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(max-width: 989px)").matches) return;
    var frame = 0;
    var last = null;
    art.addEventListener("pointermove", function (e) {
      last = e;
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        var rect = art.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var px = (last.clientX - rect.left) / rect.width - 0.5;
        var py = (last.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = "translateY(-7px) rotateX(" + (-py * 1.5).toFixed(2) + "deg) rotateY(" + (px * 2).toFixed(2) + "deg)";
      });
    });
    art.addEventListener("pointerleave", function () {
      if (frame) {
        window.cancelAnimationFrame(frame);
        frame = 0;
      }
      img.style.transform = "";
    });
  }

  function chipButton(label, on, mode, onPick) {
    var dead = mode === "dead";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ri-singles__chip" + (on && !dead ? " is-on" : dead ? " is-dead" : mode === "out" ? " is-out" : " is-stock");
    btn.textContent = label;
    btn.setAttribute("aria-pressed", on && !dead ? "true" : "false");
    if (dead) {
      btn.disabled = true;
      btn.tabIndex = -1;
      return btn;
    }
    btn.addEventListener("click", function () {
      onPick();
    });
    return btn;
  }

  /* Scrolls so a card's top sits just under whatever is stuck to the top of the screen (the site header, and the
     card search bar on a phone). Only when the top is out of sight above that line. */
  function bringTileTop(tileNode) {
    var header = document.querySelector(".section-header");
    var line = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    if (barEl && getComputedStyle(barEl).position === "sticky") {
      var bar = barEl.getBoundingClientRect();
      if (bar.top <= line + 1) line = Math.max(line, bar.bottom);
    }
    var top = tileNode.getBoundingClientRect().top;
    if (top >= line) return;
    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: window.scrollY + top - line - 8, behavior: still ? "auto" : "smooth" });
  }

  /* fold (optional): a card with more than 5 printings keeps its out-of-stock ones behind "+N more" until opened
     (owner, 2026-10-22: those cards ran very tall). { open: bool, onToggle(open) }. The one picked always shows. */
  function switchRow(caption, values, current, missing, onPick, fold) {
    var row = document.createElement("div");
    row.className = "ri-singles__switch";
    var label = document.createElement("span");
    label.className = "ri-singles__switch-label";
    label.textContent = caption;
    var chips = document.createElement("div");
    chips.className = "ri-singles__chips";
    var tucked = fold && values.length > 5
      ? values.filter(function (value) {
          return value !== current && missing(value) === "dead";
        })
      : [];
    values.forEach(function (value) {
      if (tucked.length && !fold.open && tucked.indexOf(value) !== -1) return;
      chips.appendChild(chipButton(value, value === current, missing(value), function () {
        onPick(value);
      }));
    });
    if (tucked.length) {
      var more = document.createElement("button");
      more.type = "button";
      more.className = "ri-singles__chip ri-singles__chip--more";
      more.textContent = fold.open ? "Show less" : "+" + tucked.length + " more";
      more.setAttribute("aria-expanded", fold.open ? "true" : "false");
      if (!fold.open) more.setAttribute("aria-label", "Show " + tucked.length + " more " + caption.toLowerCase() + "s (out of stock)");
      more.addEventListener("click", function () {
        fold.onToggle(!fold.open);
      });
      chips.appendChild(more);
    }
    row.appendChild(label);
    row.appendChild(chips);
    return row;
  }

  function tileEl(group) {
    var pick = resolvePick(group);
    var chosen = findOption(group, pick.finish, pick.condition);
    var tile = document.createElement("article");
    tile.className = "ri-singles__card";
    var art = document.createElement("div");
    art.className = "ri-singles__media";
    var photo = cardPhoto(group);
    var img = null;
    if (photo) {
      img = document.createElement("img");
      img.alt = group.name;
      img.width = 488;
      img.height = 680;
      var fullPhoto = sharpPhoto(photo);
      img.setAttribute("data-src", fullPhoto);
      img.addEventListener("error", function () {
        var failed = img.getAttribute("src");
        if (failed && failed !== fullPhoto && failed !== photo) {
          img.src = fullPhoto;
          return;
        }
        if (failed !== photo) {
          img.src = photo;
          return;
        }
        img.remove();
        var missing = document.createElement("span");
        missing.className = "ri-singles__no-image";
        missing.textContent = "No image";
        art.appendChild(missing);
      });
      art.appendChild(img);
    } else {
      var missingArt = document.createElement("span");
      missingArt.className = "ri-singles__no-image";
      missingArt.textContent = "No image";
      art.appendChild(missingArt);
    }
    bindTilt(art, img);
    var body = document.createElement("div");
    body.className = "ri-singles__body";
    var name = document.createElement("h2");
    name.className = "ri-singles__name";
    name.textContent = group.name;
    body.appendChild(name);
    if (group.set || group.number) {
      var meta = document.createElement("p");
      meta.className = "ri-singles__meta";
      var bits = [];
      if (group.set) bits.push(group.set);
      if (group.number) bits.push("#" + group.number);
      meta.textContent = bits.join(" - ");
      body.appendChild(meta);
    }
    var finishes = optionList(group, "finish");
    var conditions = optionList(group, "condition").filter(function (value) {
      return conditionStocked(group, value);
    });
    function refresh() {
      var next = tileEl(group);
      tile.replaceWith(next);
      // The new tile only has data-src; load it now (it is on screen and cached) so the photo does not blank out.
      var photo = next.querySelector("img[data-src]");
      if (photo) startCardPhoto(photo, true, false);
      return next;
    }
    if (phone.matches && finishes.length === 1 && conditions.length === 1) {
      var tags = document.createElement("p");
      tags.className = "ri-singles__tags";
      [["Printing", finishes[0]], ["Condition", conditions[0]]].forEach(function (pair) {
        var tag = document.createElement("span");
        tag.className = "ri-singles__tag";
        tag.textContent = pair[1];
        tag.setAttribute("aria-label", pair[0] + ": " + pair[1]);
        tags.appendChild(tag);
      });
      body.appendChild(tags);
    } else {
      body.appendChild(switchRow("Printing", finishes, pick.finish, function (value) {
        return finishStocked(group, value) ? "stock" : "dead";
      }, function (value) {
        if (!finishStocked(group, value)) return;
        pick.finish = value;
        if (!inStockOption(group, pick.finish, pick.condition)) {
          var partner = bestConditionFor(group, pick.finish);
          if (inStockOption(group, pick.finish, partner)) pick.condition = partner;
        }
        refresh();
      }, {
        open: !!group.showAllPrintings,
        onToggle: function (open) {
          group.showAllPrintings = open;
          var next = refresh();
          /* Show less on a long card (owner, 2026-10-23): the card shrinks under the finger and the page was left
             partway down the next cards. Bring the card's top back just under the sticky header and search bar. */
          if (!open && next) bringTileTop(next);
        }
      }));
      body.appendChild(switchRow("Condition", conditions, pick.condition, function (value) {
        return inStockOption(group, pick.finish, value) ? "stock" : "out";
      }, function (value) {
        pick.condition = value;
        if (!inStockOption(group, pick.finish, pick.condition)) {
          var partnerFinish = bestFinishFor(group, pick.condition);
          if (inStockOption(group, partnerFinish, pick.condition)) pick.finish = partnerFinish;
        }
        refresh();
      }));
    }
    var commerce = document.createElement("div");
    commerce.className = "ri-singles__commerce";
    var price = document.createElement("p");
    price.className = "ri-singles__price";
    var inStock = chosen && chosen.qty > 0;
    if (inStock) price.appendChild(moneyEl(chosen.price));
    var qty = document.createElement("p");
    qty.className = "ri-singles__qty";
    if (inStock) qty.textContent = chosen.qty === 1 ? "1 in stock" : chosen.qty + " in stock";
    commerce.appendChild(price);
    commerce.appendChild(qty);
    body.appendChild(commerce);
    tile.appendChild(art);
    tile.appendChild(body);
    return tile;
  }

  function checkRow(label, count, checked, indeterminate, onChange) {
    var li = document.createElement("li");
    var lab = document.createElement("label");
    lab.className = "ri-singles__check";
    var input = document.createElement("input");
    input.type = "checkbox";
    input.checked = checked;
    if (indeterminate) input.indeterminate = true;
    input.addEventListener("change", function () {
      onChange(input.checked);
      paint(true);
    });
    var text = document.createElement("span");
    text.className = "ri-singles__check-text";
    var shownWrap = document.createElement("span");
    shownWrap.className = "ri-singles__check-label";
    shownWrap.setAttribute("data-label", label);
    var shown = document.createElement("span");
    shown.className = "ri-singles__check-shown";
    shown.appendChild(document.createTextNode(label));
    var num = document.createElement("span");
    num.className = "ri-singles__check-count";
    num.textContent = " (" + count + ")";
    shown.appendChild(num);
    shownWrap.appendChild(shown);
    text.appendChild(shownWrap);
    lab.appendChild(input);
    lab.appendChild(text);
    li.appendChild(lab);
    return li;
  }

  function setGroups() {
    var en = {};
    var ja = {};
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var setName = card.set;
      if (!setName) continue;
      var bucket = card.lang === "JA" ? ja : en;
      var release = card.released ? Date.parse(card.released) : 0;
      if (!isFinite(release)) release = 0;
      var prev = bucket[setName];
      if (!prev || release > prev.release) {
        bucket[setName] = { series: card.series || "Other", release: release };
      }
    }
    for (var name in ja) delete en[name];
    function groups(bucket) {
      var bySeries = {};
      Object.keys(bucket).forEach(function (setName) {
        var meta = bucket[setName];
        if (!bySeries[meta.series]) bySeries[meta.series] = { sets: [], newest: 0 };
        bySeries[meta.series].sets.push({ name: setName, release: meta.release });
        if (meta.release > bySeries[meta.series].newest) bySeries[meta.series].newest = meta.release;
      });
      return Object.keys(bySeries)
        .map(function (series) {
          var data = bySeries[series];
          data.sets.sort(function (a, b) {
            return b.release - a.release || a.name.localeCompare(b.name);
          });
          return { series: series, newest: data.newest, sets: data.sets.map(function (s) { return s.name; }) };
        })
        .sort(function (a, b) {
          if (a.series === "Other") return 1;
          if (b.series === "Other") return -1;
          return b.newest - a.newest || a.series.localeCompare(b.series);
        });
    }
    var english = groups(en);
    var japanese = groups(ja);
    return {
      english: english,
      japanese: japanese,
      all: english.concat(japanese).reduce(function (acc, group) {
        return acc.concat(group.sets);
      }, []),
    };
  }

  function countMap(keyFn) {
    var map = {};
    var seen = {};
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.qty < 1) continue;
      var key = keyFn(card);
      if (!key) continue;
      var uniq = key + "\u0001" + cardKey(card);
      if (seen[uniq]) continue;
      seen[uniq] = true;
      map[key] = (map[key] || 0) + 1;
    }
    return map;
  }

  function renderLanguage(parent, title, groups, counts) {
    if (!groups.length) return;
    var flat = [];
    groups.forEach(function (group) {
      group.sets.forEach(function (name) { flat.push(name); });
    });
    var qNorm = setQuery.trim().toLowerCase();
    var expanded = !!setsExpanded[title] || phone.matches;
    var visible = {};
    flat.forEach(function (name, index) {
      if (qNorm) {
        if (name.toLowerCase().indexOf(qNorm) !== -1) visible[name] = true;
      } else if (expanded || index < SET_SHOW_MORE || selectedSets[name]) {
        visible[name] = true;
      }
    });
    var any = false;
    for (var key in visible) if (visible[key]) any = true;
    if (!any) return;
    var block = document.createElement("div");
    block.className = "ri-singles__lang-block";
    var heading = document.createElement("p");
    heading.className = "ri-singles__lang";
    heading.textContent = title;
    block.appendChild(heading);
    var list = document.createElement("ul");
    list.className = "ri-singles__list";
    groups.forEach(function (group) {
      var shown = group.sets.filter(function (name) { return visible[name]; });
      if (!shown.length) return;
      var allOn = group.sets.every(function (name) { return selectedSets[name]; });
      var some = group.sets.some(function (name) { return selectedSets[name]; });
      var li = document.createElement("li");
      li.appendChild(
        checkRow("All " + group.series, sumCounts(group.sets, counts), allOn, some && !allOn, function (on) {
          group.sets.forEach(function (name) {
            if (on) selectedSets[name] = true;
            else delete selectedSets[name];
          });
        })
      );
      var nested = document.createElement("ul");
      nested.className = "ri-singles__nested";
      shown.forEach(function (setName) {
        nested.appendChild(
          checkRow(setName, counts[setName] || 0, !!selectedSets[setName], false, function (on) {
            if (on) selectedSets[setName] = true;
            else delete selectedSets[setName];
          })
        );
      });
      li.appendChild(nested);
      list.appendChild(li);
    });
    block.appendChild(list);
    if (!qNorm && flat.length > SET_SHOW_MORE && !phone.matches) {
      var more = document.createElement("button");
      more.type = "button";
      more.className = "ri-singles__more";
      more.textContent = expanded ? "Show less" : "Show more";
      more.addEventListener("click", function () {
        setsExpanded[title] = !setsExpanded[title];
        renderFacets();
      });
      block.appendChild(more);
    }
    parent.appendChild(block);
  }

  function sumCounts(names, counts) {
    var n = 0;
    for (var i = 0; i < names.length; i++) n += counts[names[i]] || 0;
    return n;
  }

  /* Facet titles are buttons. On a phone each one opens its own list under it, like the collection filters.
     Which one is open is remembered, because the facets are rebuilt on every filter change. */
  function facetTitle(text, picked) {
    var title = document.createElement("button");
    title.type = "button";
    title.className = "ri-singles__facet-title";
    title.setAttribute("aria-expanded", "false");
    title.textContent = text;
    if (picked) {
      var n = document.createElement("span");
      n.className = "ri-singles__facet-n";
      n.setAttribute("data-n", String(picked));
      n.setAttribute("aria-label", picked + " picked");
      title.appendChild(n);
    }
    return title;
  }

  function facetSection(key, title) {
    var section = document.createElement("section");
    section.className = "ri-singles__facet";
    section.setAttribute("data-facet", key);
    section.appendChild(title);
    var body = document.createElement("div");
    body.className = "ri-singles__facet-body";
    section.appendChild(body);
    facetsEl.appendChild(section);
    return body;
  }

  /* kept: the list was already open before a rebuild, so it does not slide in again. */
  function placeOpenFacet() {
    if (!phone.matches) return;
    var section = openFacetKey
      ? facetsEl.querySelector('.ri-singles__facet[data-facet="' + openFacetKey + '"]')
      : facetsEl.querySelector(".ri-singles__facet.is-open, .ri-singles__facet.is-closing");
    var body = section && section.querySelector(".ri-singles__facet-body");
    var bar = root.querySelector(".ri-singles__bar");
    if (!body || !bar) return;
    var box = bar.getBoundingClientRect();
    body.style.top = Math.round(box.bottom) + "px";
    body.style.left = Math.round(box.left) + "px";
    body.style.width = Math.round(box.width) + "px";
    var cap = window.innerHeight * 0.56;
    body.classList.toggle("is-tall", body.scrollHeight > cap + 1);
  }

  function syncOpenFacet(kept) {
    var sections = facetsEl.querySelectorAll(".ri-singles__facet");
    for (var i = 0; i < sections.length; i++) {
      var open = !!openFacetKey && sections[i].getAttribute("data-facet") === openFacetKey;
      sections[i].classList.toggle("is-open", open);
      sections[i].classList.toggle("is-kept", open && !!kept);
      sections[i].classList.remove("is-closing");
      var title = sections[i].querySelector(".ri-singles__facet-title");
      if (title) title.setAttribute("aria-expanded", open ? "true" : "false");
      var body = sections[i].querySelector(".ri-singles__facet-body");
      if (body && !open) {
        body.style.top = "";
        body.style.left = "";
        body.style.width = "";
      }
    }
    placeOpenFacet();
  }

  function syncFacetEdge() {
    var over = phone.matches && facetsEl.scrollWidth > facetsEl.clientWidth + 1;
    facetsEl.classList.toggle("is-overflow", over);
    facetsEl.classList.toggle("is-end", over && facetsEl.scrollLeft + facetsEl.clientWidth >= facetsEl.scrollWidth - 1);
  }

  facetsEl.addEventListener("scroll", syncFacetEdge, { passive: true });
  window.addEventListener("resize", function () {
    syncFacetEdge();
    placeOpenFacet();
  });
  window.addEventListener("scroll", placeOpenFacet, { passive: true });

  var closingTimer = 0;
  function closeFacet(instant) {
    if (!openFacetKey) return;
    var section = facetsEl.querySelector('.ri-singles__facet[data-facet="' + openFacetKey + '"]');
    openFacetKey = "";
    window.clearTimeout(closingTimer);
    var still = instant || !section || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (still) {
      syncOpenFacet();
      return;
    }
    var title = section.querySelector(".ri-singles__facet-title");
    if (title) title.setAttribute("aria-expanded", "false");
    section.classList.remove("is-kept");
    section.classList.add("is-closing");
    placeOpenFacet();
    closingTimer = window.setTimeout(function () {
      if (!openFacetKey) syncOpenFacet();
    }, 220);
  }

  facetsEl.addEventListener("click", function (event) {
    var title = event.target.closest && event.target.closest(".ri-singles__facet-title");
    if (!title || !phone.matches) return;
    var key = title.parentNode.getAttribute("data-facet") || "";
    if (openFacetKey === key) {
      closeFacet(false);
      return;
    }
    window.clearTimeout(closingTimer);
    openFacetKey = key;
    var sortDetails = root.querySelector(".ri-singles__sort .ri-sort__details");
    if (sortDetails) sortDetails.open = false;
    syncOpenFacet();
  });

  document.addEventListener("pointerdown", function (event) {
    if (!openFacetKey || !phone.matches) return;
    if (facetsEl.contains(event.target)) return;
    closeFacet(false);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !openFacetKey || !phone.matches) return;
    var title = facetsEl.querySelector('.ri-singles__facet[data-facet="' + openFacetKey + '"] .ri-singles__facet-title');
    closeFacet(false);
    if (title) title.focus();
  });

  function renderFacets() {
    var query = setQuery;
    var keptKey = openFacetKey;
    var openBody = keptKey ? facetsEl.querySelector('.ri-singles__facet[data-facet="' + keptKey + '"] .ri-singles__facet-body') : null;
    var keptScroll = openBody ? openBody.scrollTop : 0;
    facetsEl.replaceChildren();
    if (!cards.length) return;

    facetSection("price", facetTitle("Price")).appendChild(priceControl());

    var langCounts = countMap(cardLanguage);
    var langNames = LANGUAGES.filter(function (name) { return langCounts[name]; });
    if (langNames.length > 1) {
      var langBody = facetSection("language", facetTitle("Language", selectedCount(selectedLanguages)));
      var langList = document.createElement("ul");
      langList.className = "ri-singles__list";
      langNames.forEach(function (name) {
        langList.appendChild(
          checkRow(name, langCounts[name], !!selectedLanguages[name], false, function (on) {
            if (on) selectedLanguages[name] = true;
            else delete selectedLanguages[name];
            /* Condition and Set go away while Chinese is picked (below), so their picks go too: a hidden filter
               would keep narrowing the cards with nothing on screen to undo it. */
            if (on && name === "Chinese") {
              selectedConditions = {};
              selectedSets = {};
              setQuery = "";
            }
          })
        );
      });
      langBody.appendChild(langList);
    }

    /* While Chinese is picked under Language, Condition and Set are hidden, on a phone and a computer, until it is
       unpicked (owner, 2026-10-23). */
    var chineseOn = !!selectedLanguages.Chinese;

    var conditionCounts = countMap(function (card) { return card.condition; });
    var conditionNames = Object.keys(conditionCounts).filter(function (name) {
      return !isChineseCondition(name);
    }).sort(function (a, b) {
      return conditionRank(a) - conditionRank(b) || a.localeCompare(b);
    });
    if (!chineseOn && conditionNames.length > 1) {
      var condBody = facetSection("condition", facetTitle("Condition", selectedCount(selectedConditions)));
      var condList = document.createElement("ul");
      condList.className = "ri-singles__list";
      conditionNames.forEach(function (name) {
        condList.appendChild(
          checkRow(name, conditionCounts[name], !!selectedConditions[name], false, function (on) {
            if (on) selectedConditions[name] = true;
            else delete selectedConditions[name];
          })
        );
      });
      condBody.appendChild(condList);
    }

    var groups = setGroups();
    if (!chineseOn && groups.all.length > 1) {
      var setSection = facetSection("set", facetTitle("Set", selectedCount(selectedSets)));
      if (groups.all.length > SET_SEARCH_AT) {
        var setSearch = document.createElement("input");
        setSearch.type = "search";
        setSearch.className = "ri-singles__set-search";
        setSearch.placeholder = "Search Set";
        setSearch.value = query;
        setSearch.setAttribute("aria-label", "Search Set");
        setSearch.addEventListener("input", function () {
          setQuery = setSearch.value;
          renderFacets();
          var next = facetsEl.querySelector(".ri-singles__set-search");
          if (next) {
            next.focus();
            var len = next.value.length;
            if (next.setSelectionRange) next.setSelectionRange(len, len);
          }
        });
        setSection.appendChild(setSearch);
      }
      var setCounts = countMap(function (card) { return card.set; });
      renderLanguage(setSection, "English", groups.english, setCounts);
      renderLanguage(setSection, "Japanese", groups.japanese, setCounts);
    }

    syncFacetEdge();
    if (keptKey && !facetsEl.querySelector('.ri-singles__facet[data-facet="' + keptKey + '"]')) openFacetKey = "";
    syncOpenFacet(!!openFacetKey);
    if (openFacetKey && keptScroll) {
      var nextBody = facetsEl.querySelector('.ri-singles__facet[data-facet="' + openFacetKey + '"] .ri-singles__facet-body');
      if (nextBody) nextBody.scrollTop = keptScroll;
    }

    var n = activeFacetCount();
    if (n > 0) {
      filterCountEl.hidden = false;
      filterCountEl.textContent = String(n);
    } else {
      filterCountEl.hidden = true;
      filterCountEl.textContent = "";
    }
  }

  function priceControl() {
    var wrap = document.createElement("div");
    wrap.className = "ri-price-slider";
    syncPriceVars(wrap);

    var inputs = document.createElement("div");
    inputs.className = "ri-price-slider__inputs";
    inputs.appendChild(priceField("Minimum price", priceMin, function (n) {
      priceMin = clamp(n, bounds.min, priceMax);
    }));
    var sep = document.createElement("span");
    sep.className = "ri-price-slider__sep";
    sep.setAttribute("aria-hidden", "true");
    sep.textContent = "\u2013";
    inputs.appendChild(sep);
    inputs.appendChild(priceField("Maximum price", priceMax, function (n) {
      priceMax = clamp(n, priceMin, bounds.max);
    }));
    wrap.appendChild(inputs);

    var control = document.createElement("div");
    control.className = "ri-price-slider__control";
    var track = document.createElement("div");
    track.className = "ri-price-slider__track";
    track.setAttribute("aria-hidden", "true");
    var fill = document.createElement("div");
    fill.className = "ri-price-slider__fill";
    track.appendChild(fill);
    control.appendChild(track);
    control.appendChild(rangeEl("min", priceMin, function (n) {
      priceMin = clamp(n, bounds.min, priceMax);
    }));
    control.appendChild(rangeEl("max", priceMax, function (n) {
      priceMax = clamp(n, priceMin, bounds.max);
    }));
    wrap.appendChild(control);
    return wrap;
  }

  function syncPriceVars(wrap) {
    var span = Math.max(1, bounds.max - bounds.min);
    var minPct = ((priceMin - bounds.min) / span) * 100;
    var maxPct = ((priceMax - bounds.min) / span) * 100;
    wrap.style.setProperty("--ri-price-min", minPct + "%");
    wrap.style.setProperty("--ri-price-max", maxPct + "%");
    var track = wrap.querySelector(".ri-price-slider__track");
    if (track) {
      track.style.setProperty("--ri-price-min", minPct + "%");
      track.style.setProperty("--ri-price-max", maxPct + "%");
    }
  }

  function clamp(n, min, max) {
    if (!isFinite(n)) return min;
    return Math.min(max, Math.max(min, n));
  }

  function priceField(label, value, apply) {
    var field = document.createElement("label");
    field.className = "ri-price-slider__field";
    var currency = document.createElement("span");
    currency.className = "ri-price-slider__currency";
    currency.setAttribute("aria-hidden", "true");
    currency.textContent = "$";
    var input = document.createElement("input");
    input.type = "number";
    input.className = "ri-price-slider__input";
    input.inputMode = "numeric";
    input.min = String(bounds.min);
    input.max = String(bounds.max);
    input.step = "1";
    input.value = String(Math.round(value));
    input.setAttribute("aria-label", label);
    input.addEventListener("change", function () {
      priceTouched = true;
      apply(Number(input.value));
      paint(true);
    });
    field.appendChild(currency);
    field.appendChild(input);
    return field;
  }

  function rangeEl(which, value, apply) {
    var input = document.createElement("input");
    input.type = "range";
    input.className = "ri-price-slider__thumb ri-price-slider__thumb--" + which;
    input.min = String(bounds.min);
    input.max = String(bounds.max);
    input.step = "1";
    input.value = String(Math.round(value));
    input.setAttribute("aria-label", which === "min" ? "Minimum price slider" : "Maximum price slider");
    input.addEventListener("input", function () {
      priceTouched = true;
      apply(Number(input.value));
      var wrap = input.parentElement && input.parentElement.parentElement;
      if (wrap) {
        syncPriceVars(wrap);
        var fields = wrap.querySelectorAll(".ri-price-slider__input");
        if (fields[0]) fields[0].value = String(Math.round(priceMin));
        if (fields[1]) fields[1].value = String(Math.round(priceMax));
      }
      renderGrid(filteredGroups());
      var n = activeFacetCount();
      filterCountEl.hidden = n < 1;
      filterCountEl.textContent = n > 0 ? String(n) : "";
    });
    input.addEventListener("change", function () {
      paint(true);
    });
    return input;
  }

  function paint(scrollAfter) {
    renderFacets();
    renderGrid(filteredGroups());
    if (!scrollAfter || root.classList.contains("is-filtering")) return;
    if (phone.matches) scrollToResults();
    else if (window.matchMedia("(min-width: 750px)").matches) window.scrollTo(0, 0);
  }

  function filtersActive() {
    if (search.trim()) return true;
    if (selectedCount(selectedSets) > 0) return true;
    if (selectedCount(selectedConditions) > 0) return true;
    if (selectedCount(selectedLanguages) > 0) return true;
    if (priceTouched) return true;
    return false;
  }

  function clearFilters() {
    search = "";
    if (searchEl) searchEl.value = "";
    selectedSets = {};
    selectedConditions = {};
    selectedLanguages = {};
    setQuery = "";
    priceTouched = false;
    priceMin = bounds.min;
    priceMax = bounds.max;
    paint(false);
  }

  var loadEl = document.getElementById("riSinglesLoad");

  function hideLoad() {
    if (loadEl) loadEl.hidden = true;
  }

  function applyCards(list, fromNetwork) {
    cards = list;
    setBoundsFromCards(cards);
    if (fromNetwork) {
      saveSession(cards);
      hideLoad();
    }
    statusEl.hidden = true;
    paint(false);
  }

  function setStatus(message) {
    hideLoad();
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  var searchTimer = 0;
  searchEl.addEventListener("input", function () {
    search = searchEl.value;
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(function () {
      renderGrid(filteredGroups());
      resultsToTop();
    }, 80);
  });
  searchEl.addEventListener("focus", function () {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (searchEl.value) {
      queueMicrotask(function () {
        try { searchEl.select(); } catch (err) { /* ignore */ }
      });
    }
    requestAnimationFrame(function () {
      var now = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (now !== scrollY && Math.abs(now - scrollY) < 180) window.scrollTo(0, scrollY);
    });
  });
  if (searchForm) {
    searchForm.addEventListener("submit", function (event) {
      event.preventDefault();
      search = searchEl.value;
      window.clearTimeout(searchTimer);
      renderGrid(filteredGroups());
      /* Search (the button, or the phone keyboard's Search key) puts the keyboard away and shows the first results. */
      searchEl.blur();
      resultsToTop();
    });
  }

  sortEl.addEventListener("input", function () {
    syncSortLabel();
    renderGrid(filteredGroups());
    if (phone.matches) scrollToResults();
  });

  function columnCount() {
    if (!gridEl) return 5;
    var value = window.getComputedStyle(gridEl).gridTemplateColumns;
    if (!value || value === "none") return 5;
    var repeat = /repeat\(\s*(\d+)/.exec(value);
    if (repeat) return Number(repeat[1]);
    var count = 0;
    var parts = value.split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      if (/^[\d.]+(?:px|fr|%)$/.test(parts[i])) count += 1;
    }
    return count || 5;
  }

  function paintCols(n) {
    n = Math.max(COLS_MIN, Math.min(COLS_MAX, n));
    var pct = ((n - COLS_MIN) / (COLS_MAX - COLS_MIN)) * 100;
    if (colsEl) {
      colsEl.value = String(n);
      colsEl.setAttribute("aria-valuenow", String(n));
      colsEl.style.setProperty("--ri-cols-pct", pct + "%");
      if (colsEl.parentElement) colsEl.parentElement.style.setProperty("--ri-cols-pct", pct + "%");
    }
    if (colsValueEl) colsValueEl.textContent = String(n);
    return n;
  }

  function applyCols(n, custom) {
    n = paintCols(n);
    if (!custom) return;
    colsCustom = true;
    root.style.setProperty("--ri-singles-cols", String(n));
    root.classList.add("is-cols-custom");
    upgradeCardPhotos();
    try {
      sessionStorage.setItem(COLS_KEY, String(n));
    } catch (e) {
      /* ignore */
    }
  }

  function initCols() {
    var saved = 0;
    try {
      saved = Number(sessionStorage.getItem(COLS_KEY));
    } catch (e) {
      saved = 0;
    }
    if (saved >= COLS_MIN && saved <= COLS_MAX) {
      applyCols(saved, true);
      return;
    }
    paintCols(columnCount());
  }

  if (colsEl) {
    function onColsInput() {
      applyCols(Number(colsEl.value), true);
    }
    colsEl.addEventListener("input", onColsInput);
    colsEl.addEventListener("change", onColsInput);
    initCols();
    var colsMain = root.querySelector(".ri-singles__main");
    if (window.ResizeObserver && colsMain) {
      new ResizeObserver(function () {
        if (colsCustom) return;
        if (!window.matchMedia("(min-width: 990px)").matches) return;
        paintCols(columnCount());
      }).observe(colsMain);
    }
  }

  /* On a phone the filters leave the side rail and join the sticky bar. The same node moves back on a wider screen. */
  function placeForWidth() {
    if (phone.matches) {
      if (barFacetsEl && facetsEl.parentNode !== barFacetsEl) barFacetsEl.appendChild(facetsEl);
    } else {
      closeFacet(true);
      if (railEl && facetsEl.parentNode !== railEl) railEl.insertBefore(facetsEl, facetsHome);
    }
  }

  /* On a phone the sort button is already as wide as its longest option, so it is locked to that whole-pixel
     width and data-sort-fixed keeps the shared sort script from resizing it when it opens. */
  var sortDetailsEl = root.querySelector(".ri-singles__sort .ri-sort__details");
  function lockSortWidth() {
    if (!sortDetailsEl) return;
    sortDetailsEl.open = false;
    sortDetailsEl.removeAttribute("data-sort-fixed");
    sortDetailsEl.style.width = "";
    if (!phone.matches) return;
    sortDetailsEl.setAttribute("data-sort-fixed", "");
    sortDetailsEl.style.width = Math.ceil(sortDetailsEl.getBoundingClientRect().width) + "px";
  }

  placeForWidth();
  lockSortWidth();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
    if (sortDetailsEl && !sortDetailsEl.open) lockSortWidth();
  });
  phone.addEventListener("change", function () {
    placeForWidth();
    lockSortWidth();
    if (cards.length) {
      renderFacets();
      renderGrid(filteredGroups());
    }
  });

  document.getElementById("riSinglesFilterOpen").addEventListener("click", function () {
    root.classList.add("is-filtering");
  });
  function closeFilters() {
    root.classList.remove("is-filtering");
  }
  document.getElementById("riSinglesFilterClose").addEventListener("click", closeFilters);
  document.getElementById("riSinglesSee").addEventListener("click", function () {
    closeFilters();
    window.scrollTo(0, 0);
  });
  var clearBtn = document.getElementById("riSinglesClear");
  if (clearBtn) clearBtn.addEventListener("click", clearFilters);

  var cached = loadSession();
  /* On a phone the loading bar means a blank grid. The list from earlier in the visit waits until this load finishes. */
  if (cached.length && !phone.matches) applyCards(cached, false);

  if (!ENDPOINT || ENDPOINT.indexOf("/apps/trade/") !== 0) {
    if (!cards.length) setStatus("The catalog could not load. Try again.");
    return;
  }

  fetch(ENDPOINT, { credentials: "same-origin" })
    .then(function (res) {
      if (!res.ok) throw new Error("load");
      return res.json();
    })
    .then(function (data) {
      var next = sanitizeCards(data && data.cards);
      if (!next.length && !cards.length && cached.length) applyCards(cached, false);
      if (!next.length && cards.length) {
        setStatus("Showing the list from earlier in this visit.");
        return;
      }
      applyCards(next, true);
      if (!next.length) setStatus("No singles are in stock right now.");
    })
    .catch(function () {
      if (!cards.length && cached.length) applyCards(cached, false);
      if (cards.length) setStatus("Showing the list from earlier in this visit.");
      else setStatus("The catalog could not load. Try again.");
    });
})();
